import React from 'react';

import styles from '@UILayer/UILayer.scss';

export const ReadyStateCheckIcon: React.FC<{}> = () => {
    return (
        <svg className={styles.rsc_icon} x="0px" y="0px" viewBox="0 0 78.9 71.3">
            <path
                className={styles.rsc_icon_path}
                d="M67.7,71.3H11.2c-4,0-7.7-2.1-9.7-5.6s-2-7.7,0-11.2l28.3-49c2-3.5,5.6-5.6,9.7-5.6
	c4,0,7.7,2.1,9.7,5.6l28.3,49c2,3.5,2,7.7,0,11.2C75.4,69.2,71.8,71.3,67.7,71.3z M39.5,5c-2.2,0-4.2,1.2-5.4,3.1l-28.3,49
	c-1.1,1.9-1.1,4.2,0,6.2s3.1,3.1,5.4,3.1h56.5c2.2,0,4.2-1.2,5.4-3.1s1.1-4.2,0-6.2l-28.3-49C43.7,6.2,41.7,5,39.5,5z"
            />
            <g>
                <path
                    className={styles.rsc_icon_path}
                    d="M39.5,60.9c-1.2,0-2.3-0.4-3.2-1.3c-0.9-0.9-1.3-1.9-1.3-3.2c0-1.3,0.4-2.3,1.3-3.2s1.9-1.3,3.2-1.3
		c1.3,0,2.3,0.4,3.2,1.3s1.3,1.9,1.3,3.2c0,1.2-0.4,2.3-1.3,3.2C41.8,60.5,40.7,60.9,39.5,60.9z M36.5,46.4l-0.2-29.7h6.3l-0.3,29.7
		H36.5z"
                />
            </g>
        </svg>
    );
};
